import * as React from "react";
import { forwardRef } from "react";
const VisaIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#F1AD2B",
  fillRule: "evenodd",
  d: "M5 35.8234h37.7832v-3.4296H5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#182E66",
  fillRule: "evenodd",
  d: "M5 15.4296h37.7832V12H5zm18.5657 3.7785-1.9915 9.4268h-2.4089l1.9918-9.4268zm10.1341 6.0872 1.2681-3.5403.7294 3.5403zm2.6889 3.3396h2.2272l-1.946-9.4268h-2.0545c-.4632 0-.8534.2718-1.0262.691l-3.6145 8.7358h2.5299l.5021-1.4077h3.09zm-6.2884-3.0775c.0105-2.4877-3.3969-2.6257-3.3743-3.7374.0075-.3378.3256-.6974 1.0215-.7894.3449-.0451 1.2967-.0815 2.3757.4217l.422-1.9998c-.5797-.2122-1.3254-.4167-2.2532-.4167-2.3813 0-4.0566 1.2807-4.07 3.116-.0152 1.3572 1.1968 2.114 2.1079 2.566.9394.4619 1.2542.7583 1.2497 1.1711-.0065.6324-.7493.9125-1.4406.9229-1.2118.0193-1.9141-.3314-2.4739-.5957l-.4372 2.0667c.5636.2611 1.6025.4886 2.6779.5002 2.5315 0 4.187-1.2656 4.1945-3.2256m-9.9765-6.3493-3.9029 9.4268h-2.546l-1.9209-7.5233c-.1163-.4624-.2178-.6326-.5719-.8279-.5793-.3188-1.53561-.6167-2.37631-.8019l.05682-.2737h4.09889c.5223 0 .9918.3517 1.1113.9607l1.0146 5.4553 2.5058-6.416z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(VisaIcon);
export { ForwardRef as VisaIcon };